import React, { useEffect, useState } from 'react';
import '../Temporadas/Temporadas.css';
import './PantallasAdmin.css';
import { useAuth } from '../../context/AuthContext';
import { getPantallasAdmin, actualizarPantalla } from '../../services/pantallasService';

export const COLUMNAS = [
  { campo: 'visibleRolPublico', etiqueta: 'Público (sin login)' },
  { campo: 'visibleRolJugador', etiqueta: 'Jugador' },
  { campo: 'visibleRolComite', etiqueta: 'Comité' },
  { campo: 'visibleRolAdmin', etiqueta: 'Admin' },
];

// Edita la tabla `pantallas`. Cada casilla se guarda al momento; los clientes
// conectados se enteran por WebSocket. Solo ADMIN (el backend también lo exige).
export default function PantallasAdmin() {
  const { usuario } = useAuth();
  const [pantallas, setPantallas] = useState([]);
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(null);
  const esAdmin = usuario?.rol === 'ADMIN';

  useEffect(() => {
    if (!esAdmin) return;
    getPantallasAdmin()
      .then((r) => setPantallas(r.datos))
      .catch((err) => setError(err.message || 'No se pudo cargar la lista.'));
  }, [esAdmin]);

  if (!esAdmin) {
    return <div className="page"><p>Solo el administrador puede gestionar la visibilidad de las pantallas.</p></div>;
  }

  const cambiar = async (pantalla, campo, valor) => {
    setError(null);
    setGuardando(pantalla.id);
    try {
      const { datos } = await actualizarPantalla(pantalla.id, { [campo]: valor });
      setPantallas((lista) => lista.map((p) => (p.id === datos.id ? datos : p)));
    } catch (err) {
      setError(err.message || 'No se pudo guardar el cambio.');
    } finally {
      setGuardando(null);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Visibilidad de pantallas</h2>
      </div>
      <p>
        Marca en qué rol se ve cada pantalla. Los cambios se guardan al momento y llegan en vivo a quien
        tenga la web abierta. Es visibilidad de interfaz: los datos los protege cada endpoint.
        Cuidado con el login (<code>/</code>): si lo ocultas al público, nadie sin sesión podrá entrar.
      </p>
      {error && <p className="error" role="alert">{error}</p>}
      <div className="table-wrap" style={{ overflowX: 'auto' }}>
        <table className="pantallas-admin">
          <thead>
            <tr>
              <th>Pantalla</th>
              <th>URL</th>
              {COLUMNAS.map((c) => <th key={c.campo}>{c.etiqueta}</th>)}
            </tr>
          </thead>
          <tbody>
            {pantallas.map((p) => (
              <tr key={p.id}>
                <td>{p.nombre}</td>
                <td><code>{p.url}</code></td>
                {COLUMNAS.map((c) => (
                  <td key={c.campo} style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={p[c.campo]}
                      disabled={guardando === p.id}
                      aria-label={`${p.nombre} — ${c.etiqueta}`}
                      onChange={(e) => cambiar(p, c.campo, e.target.checked)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
